import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Flex, type MantineSize, Text } from '@mantine/core';
export type KycStepperStatusProps = {
  visible?: MantineSize | (string & {}) | undefined;
  hidden?: MantineSize | (string & {}) | undefined;
};
export const KycStepperStatus: React.FC<KycStepperStatusProps> = ({
  visible,
  hidden
}) => {
  const {
    i18n
  } = useLingui();
  const {
    successes
  } = useVerifyAction();
  return <Flex w="100%" justify={{
    base: 'center',
    sm: 'end',
    lg: 'center'
  }} visibleFrom={visible} hiddenFrom={hidden}>
      {successes.has(STATUS.ID_VERIFICATION) ? <Text visibleFrom="lg" px={16} className={gunterzBold.className} fz={13} c="var(--text-dark)" mb={8}>
          {i18n._('VERIFICATION ')}
          <Text span inherit c="var(--text-green)">
            {i18n._('COMPLETE')}
          </Text>
        </Text> : <Text px={16} className={gunterzBold.className} fz={13} c="var(--text-dark)" mb={8}>
          <Text span inherit c="var(--text-green)">
            {successes.size}
          </Text>
          {i18n._(' of 4 complete')}
        </Text>}
    </Flex>;
};